import { render, staticRenderFns } from "./1. Simple.vue?vue&type=template&id=07ade17d&"
import script from "./1. Simple.vue?vue&type=script&lang=js&"
export * from "./1. Simple.vue?vue&type=script&lang=js&"
import style0 from "../dist/vue-coe-calendar.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/viniazvd/vue-coe-calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07ade17d')) {
      api.createRecord('07ade17d', component.options)
    } else {
      api.reload('07ade17d', component.options)
    }
    module.hot.accept("./1. Simple.vue?vue&type=template&id=07ade17d&", function () {
      api.rerender('07ade17d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "examples/1. Simple.vue"
export default component.exports